// apps/web/src/services/ReportsService.js

import service from 'auth/FetchInterceptor'

const ReportsService = {
  getFilters(clientId) {
    return service.get('/reports/filters', {
      params: clientId
        ? {
            clientId,
          }
        : {},
    })
  },

  getSummary(params = {}) {
    return service.get('/reports/summary', {
      params,
    })
  },

  getLeads(params = {}) {
    return service.get('/reports/leads', {
      params,
    })
  },

  exportLeadsCsv(params = {}) {
    return service.get(
      '/reports/leads/export/csv',
      {
        params,
        responseType: 'blob',
      },
    )
  },

  exportLeadsXlsx(params = {}) {
    return service.get(
      '/reports/leads/export/xlsx',
      {
        params,
        responseType: 'blob',
      },
    )
  },

  exportLeadsPdf(params = {}) {
    return service.get(
      '/reports/leads/export/pdf',
      {
        params,
        responseType: 'blob',
      },
    )
  },
}

export default ReportsService